import { Film, Image as ImageIcon } from "lucide-react";
import { mediaUrl } from "@/lib/api";
import { HlsVideo } from "@/components/media/HlsVideo";

const Stack = ({ items, kind }) => (
  <div className="relative h-24 w-32 shrink-0 sm:h-28 sm:w-40">
    {items.slice(0, 3).map((it, i) => (
      <div key={it.id} className="absolute inset-0 overflow-hidden border-2 border-[#FBF9F5] bg-[#ECEAE6] shadow-md transition-transform duration-500"
        style={{ transform: `rotate(${(i - 1) * 7}deg) translate(${(i - 1) * 10}px, ${i * -3}px)`, zIndex: 3 - i }}>
        {kind === "video"
          ? <HlsVideo src={`${mediaUrl(it.media_id)}#t=0.5`} muted preload="metadata" className="h-full w-full object-cover" />
          : <img src={mediaUrl(it.media_id)} alt="" className="h-full w-full object-cover" />}
      </div>
    ))}
    {!items.length && (
      <div className="absolute inset-0 flex items-center justify-center border-2 border-dashed border-black/20">
        {kind === "video" ? <Film className="h-7 w-7 text-black/30" /> : <ImageIcon className="h-7 w-7 text-black/30" />}
      </div>
    )}
  </div>
);

export const FolderTabs = ({ folders, onOpen }) => (
  <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
    {folders.map((f) => (
        <button key={f.key} onClick={() => onOpen(f.key)} data-testid={`gallery-folder-${f.key}`}
          className="group relative flex items-center gap-6 overflow-hidden bg-[#ECEAE6] p-6 text-left text-[#0A0A0A] transition-colors duration-500 hover:bg-[#0A0A0A] hover:text-white sm:p-8">
          <Stack items={f.items} kind={f.kind} />
          <div className="min-w-0 flex-1">
            <p className="font-mono-label text-[11px] uppercase tracking-[0.25em] text-[#57534E] group-hover:text-zinc-300">Folder</p>
            <p className="mt-1 font-display text-4xl font-extrabold tracking-tight sm:text-5xl">{f.label}</p>
            <p className="mt-1 text-sm text-[#57534E] group-hover:text-zinc-300">{f.items.length} {f.items.length === 1 ? f.one : f.many}</p>
          </div>
          <span className="text-3xl transition-transform duration-500 group-hover:translate-x-2 group-hover:text-[#E62314]">→</span>
          <span className="absolute bottom-0 left-0 h-1 w-0 bg-[#E62314] transition-[width] duration-500 group-hover:w-full" />
        </button>
    ))}
  </div>
);
